import { render, staticRenderFns } from "./TextHeading5.vue?vue&type=template&id=d3e87cfa&scoped=true"
import script from "./TextHeading5.vue?vue&type=script&lang=js"
export * from "./TextHeading5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e87cfa",
  null
  
)

export default component.exports